<script setup>

import {computed, ref} from "vue";
import {round10} from "@/math";

const props = defineProps({
  standard: Object,
  couple: Boolean,
  isTotal: {type: Boolean, default: false}
})
const sliderIncrements = ref(1000)
const xvalue = computed({
  get() {
    return parseInt(props.standard.value)
  },
  set(val) {
    props.standard.value = parseInt(val)
  }
})
const sliderValue = computed({
  get() {
    function sliderPositionIsSet(sliderPosition) {
      return sliderPosition !== 0;
    }
    const fieldValue = xvalue.value;
    let sliderPosition = 0;
    sliderStops.value.forEach(function (stop, index, stops) {
      if (!sliderPositionIsSet(sliderPosition) && fieldValue <= stop.val) {
        if (stop.pos === 0) sliderPosition = 0;
        else {
          const prev = stops[index - 1];
          sliderPosition = prev.pos + ((stop.pos - prev.pos) * (fieldValue - prev.val) / (stop.val - prev.val));
        }
      }
    });
    if (!sliderPositionIsSet(sliderPosition)) sliderPosition = sliderIncrements.value;
    return sliderPosition
  },
  set(sliderPosition) {
    sliderPosition = +sliderPosition;
    var fieldValue = false;
    sliderStops.value.forEach(function (stop, index, stops) {
      if (fieldValue === false && sliderPosition <= stop.pos) {
        if (sliderPosition === 0) fieldValue = stop.val;
        else {
          const prev = stops[index - 1];
          fieldValue = prev.val + ((stop.val - prev.val) * (sliderPosition - prev.pos) / (stop.pos - prev.pos))
        }
      }
    });
    if (fieldValue !== false) xvalue.value = round10(fieldValue);
  }
})
const sliderStops = computed(() => {
  const inc = sliderIncrements.value,
      {min, mod, com} = props.couple ? props.standard.presetsCouple : props.standard.presetsSingle;
  return [
    {pos: 0, val: min, name: 'Minimum'},
    {pos: inc * 1 / 3, val: mod, name: 'Moderate'},
    {pos: inc * 2 / 3, val: com, name: 'Comfortable'},
    {pos: inc, val: com * 2, name: false}
  ]
})
const visibleStops = computed(() => {
      let stopsVisible = [];
  sliderStops.value.forEach(function (stop) {
    if (stop.name !== false) stopsVisible.push({name: stop.name, posCent: 100 * stop.pos / sliderIncrements.value})
  });
  return stopsVisible
})
const sliderClass = computed(() => {
  var sliderClass = 'standard-slider'
  sliderClass = props.isTotal ? sliderClass + ' total' : sliderClass;
  return sliderClass
})
</script>

<template>
  <div :class="sliderClass">
    <div class="ss__title">
      <span class="ss__icon" :style="{ backgroundImage: 'url(' + props.standard.iconUrl + ')'}"></span>
      <h3 class="ss__name">{{ props.standard.title }}</h3>
    </div>
    <div class="ss__slider-field">
      <input
          type="range" min="0" v-bind:max="sliderIncrements" step="1"
          v-model="sliderValue"
          class="sssf__slider"
          v-bind:disabled="props.isTotal"
      >
      <span
          v-for="(stop, index) in visibleStops"
          v-bind:key="index"
          v-bind:style="{ left: stop.posCent + '%' }"
          class="sssf__stop"
      >{{ stop.name }}
            </span>
    </div>
    <span class="ss__direct-field">
            £
            <input type="number" min="0" step="1"
                   v-model="xvalue"
                   v-bind:disabled="props.isTotal"
                   v-if="!props.isTotal">
            {{ props.isTotal ? xvalue : '' }}
            per week
        </span>
  </div>
</template>
